// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Jotai from "jotai";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as TbAtoms from "../team-planner-core/TbAtoms.bs.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as TbHexName from "../team-planner-core/TbHexName.bs.js";
import * as TbHexWrap from "../team-planner-core/TbHexWrap.bs.js";
import * as TbUtils14 from "./TbUtils14.bs.js";
import * as ReactDnd from "react-dnd";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as TbHexStarLevel from "../team-planner-core/TbHexStarLevel.bs.js";
import Popover from "@mui/material/Popover";
import MenuItem from "@mui/material/MenuItem";
import Star from "@mui/icons-material/Star";
import Clear from "@mui/icons-material/Clear";

function getItemPosition(idx, count) {
  switch (idx) {
    case 0 :
        switch (count) {
          case 1 :
              return [
                      31,
                      2
                    ];
          case 2 :
              return [
                      18,
                      2
                    ];
          case 3 :
              return [
                      6,
                      2
                    ];
          default:
            
        }
        break;
    case 1 :
        if (count === 2) {
          return [
                  43,
                  2
                ];
        }
        if (count === 3) {
          return [
                  31,
                  2
                ];
        }
        break;
    case 2 :
        if (count === 3) {
          return [
                  56,
                  2
                ];
        }
        break;
    default:
      
  }
  throw {
        RE_EXN_ID: "Assert_failure",
        _1: [
          "TeamPlannerHex14.res",
          11,
          9
        ],
        Error: new Error()
      };
}

function TeamPlannerHex14$Item(Props) {
  var itemId = Props.itemId;
  var idx = Props.idx;
  var colNum = Props.colNum;
  var rowNum = Props.rowNum;
  var onRemove = Props.onRemove;
  var basePath4 = CdnAtom.usePath4(undefined);
  var match = Jotai.useAtom(TbAtoms.disableTooltips);
  var match$1 = ReactDnd.useDrag({
        type: "hex-item",
        item: {
          id: itemId,
          type: "hex-item",
          idx: idx,
          colNum: colNum,
          rowNum: rowNum
        },
        end: (function (_item, monitor) {
            if (!monitor.didDrop()) {
              return Curry._3(onRemove, colNum, rowNum, idx);
            }
            
          }),
        collect: (function (monitor) {
            return {
                    isDragging: monitor.isDragging()
                  };
          })
      });
  return React.createElement("g", {
              ref: match$1[1]
            }, React.createElement(ItemTooltip.make, {
                  itemId: itemId,
                  children: React.createElement("rect", {
                        height: "25",
                        width: "25",
                        stroke: "rgba(255, 255, 255, 0.8)",
                        strokeWidth: "1",
                        x: "0.5",
                        y: "0.5"
                      }),
                  disabled: match[0]
                }), React.createElement("image", {
                  className: "pointer-events-none " + (
                    match$1[0].isDragging ? "opacity-50" : ""
                  ),
                  height: "24",
                  href: basePath4 + "/items_s14/" + itemId + ".jpg?w=24",
                  width: "24",
                  x: "1",
                  y: "1"
                }));
}

var Item = {
  make: TeamPlannerHex14$Item
};

function TeamPlannerHex14$Unit(Props) {
  var grayscale = Props.grayscale;
  var dragRef = Props.dragRef;
  var isDragging = Props.isDragging;
  var highlightTrait = Props.highlightTrait;
  var hexSize = Props.hexSize;
  var hexContent = Props.hex;
  var colNum = Props.colNum;
  var rowNum = Props.rowNum;
  var onRemove = Props.onRemove;
  var onRemoveItem = Props.onRemoveItem;
  var onSetStarLevel = Props.onSetStarLevel;
  var onToggleMech = Props.onToggleMech;
  var traitCounts = Props.traitCounts;
  var extraTrait = Props.extraTrait;
  var exaltedUnits = Props.exaltedUnits;
  var set = TftSet.use(undefined);
  var basePath3 = CdnAtom.usePath4(undefined);
  var t = Translation.useT(/* Common */0);
  var unitsT = Translation.useT(/* Units */1);
  var traitsT = Translation.useT(/* Traits */2);
  var match = Jotai.useAtom(TbAtoms.disableTooltips);
  var disableTooltips = match[0];
  var match$1 = Jotai.useAtom(TbAtoms.compactMode);
  var compactMode = match$1[0];
  var lang = Translation.useLocale();
  var match$2 = Jotai.useAtom(TbAtoms.useSkins);
  var match$3 = Jotai.useAtom(TbAtoms.showNames);
  var screenSize = ScreenAtom.use(undefined);
  var match$4 = React.useState(function () {
        
      });
  var starLevel = hexContent.starLevel;
  var items = hexContent.items;
  var unit = hexContent.unit;
  var setMenuAnchor = match$4[1];
  var menuAnchor = match$4[0];
  var traits;
  if (unit.TAG === /* Unit */0) {
    var unitId = unit._0;
    var traits$1 = Sd.getUnitTraits(unitId, set);
    traits = exaltedUnits.includes(unitId) ? Belt_Array.concat(traits$1, ["TFT11_Exalted"]) : traits$1;
  } else {
    traits = [];
  }
  if (extraTrait !== undefined) {
    traits.push(extraTrait);
  }
  var isHighlighted = highlightTrait !== undefined ? Belt_Array.some(traits, (function (tt) {
            return tt === highlightTrait;
          })) : true;
  var tmp = {
    className: isHighlighted && !isDragging ? "" : "opacity-30"
  };
  if (dragRef !== undefined) {
    tmp.ref = Caml_option.valFromOption(dragRef);
  }
  var tmp$1;
  if (traits.includes("TFT13_Experiment")) {
    var traitId = "TFT13_Experiment";
    tmp$1 = React.createElement(MenuItem, {
          classes: {
            root: hexContent.chosenTrait === 1 ? "text-primary-11" : "text-white1"
          },
          onClick: (function (param) {
              Curry._3(onToggleMech, colNum, rowNum, 1);
              return Curry._1(setMenuAnchor, (function (param) {
                            
                          }));
            }),
          children: React.createElement("div", {
                className: "flex"
              }, React.createElement(TraitImage.PlainIcon.make, {
                    traitId: traitId,
                    size: 22
                  }), React.createElement("div", {
                    className: "pl-[9px]"
                  }, traitsT("TFT13_Experiment"))),
          key: traitId
        });
  } else {
    tmp$1 = null;
  }
  var size = String(((hexSize | 0) << 1) - 2 | 0);
  var tmp$2;
  if (unit.TAG === /* Unit */0) {
    var unitId$1 = unit._0;
    tmp$2 = match$2[0] ? basePath3 + "/cd14/face_full/" + unitId$1 + ".jpg?w=" + size : basePath3 + "/face_base_full/" + Belt_Array.getExn(unitId$1.split("_"), 1) + ".jpg?w=" + size;
  } else {
    switch (unit._0) {
      case /* JayceSummon */0 :
          tmp$2 = basePath3 + "/ts13/face_full/TFT13_JayceSummon.png.jpg?w=" + size;
          break;
      case /* Sentinel */1 :
          tmp$2 = basePath3 + "/face_full/TFT_BlueGolem.jpg?w=" + size;
          break;
      case /* Dummy */2 :
          tmp$2 = basePath3 + "/face_full/TFT_TrainingDummy.jpg?w=" + size;
          break;
      case /* Thex */3 :
          tmp$2 = basePath3 + "/cd14/face_full/TFT14_Thex.png?w=" + size;
          break;
      
    }
  }
  var tmp$3;
  if (unit.TAG === /* Unit */0) {
    var match$5 = Sd.unitTier(unit._0);
    switch (match$5) {
      case 1 :
          tmp$3 = "rgba(187, 187, 187, 0.75)";
          break;
      case 2 :
          tmp$3 = "rgba(55, 212, 136, 0.75)";
          break;
      case 3 :
          tmp$3 = "rgba(110, 204, 255, 0.75)";
          break;
      case 4 :
          tmp$3 = "rgba(227, 50, 199, 0.75)";
          break;
      case 5 :
          tmp$3 = "rgba(255, 205, 79, 0.75)";
          break;
      default:
        tmp$3 = "rgba(187, 187, 187, 0.75)";
    }
  } else {
    tmp$3 = (unit._0 - 1 >>> 0) > 1 ? "rgba(110, 204, 255, 0.75)" : "rgba(187, 187, 187, 0.75)";
  }
  var content = React.createElement("path", {
        onClick: (function (e) {
            if (screenSize < 4) {
              return ;
            }
            e.preventDefault();
            e.stopPropagation();
            var target = e.currentTarget;
            return Curry._1(setMenuAnchor, (function (param) {
                          return Caml_option.some(target);
                        }));
          }),
        onContextMenu: (function (e) {
            if (screenSize >= 4) {
              return ;
            }
            e.preventDefault();
            e.stopPropagation();
            var target = e.currentTarget;
            return Curry._1(setMenuAnchor, (function (param) {
                          return Caml_option.some(target);
                        }));
          }),
        d: T.genHexPath(hexSize),
        fill: "transparent",
        stroke: tmp$3,
        strokeWidth: "3.5",
        transform: "translate(0.5, 0.5)"
      });
  var tmp$4;
  if (unit.TAG === /* Unit */0) {
    tmp$4 = React.createElement(UnitTooltip.make, {
          disabled: disableTooltips,
          unit: unit._0,
          children: content
        });
  } else {
    var match$6 = unit._0;
    tmp$4 = match$6 !== 2 && match$6 >= 3 ? React.createElement(UnitTooltip.make, {
            disabled: disableTooltips,
            unit: "TFT14_SummonLevel4",
            children: content
          }) : content;
  }
  var tmp$5;
  if (match$3[0]) {
    var nameParts;
    if (unit.TAG === /* Unit */0) {
      nameParts = [unitsT(unit._0)];
    } else {
      switch (unit._0) {
        case /* JayceSummon */0 :
            nameParts = [unitsT("")];
            break;
        case /* Sentinel */1 :
            nameParts = [t("TFT_BlueGolem")];
            break;
        case /* Dummy */2 :
            nameParts = [t("")];
            break;
        case /* Thex */3 :
            nameParts = [unitsT("TFT14_SummonLevel4")];
            break;
        
      }
    }
    tmp$5 = React.createElement(TbHexName.make, {
          lang: lang,
          nameParts: nameParts
        });
  } else {
    tmp$5 = null;
  }
  var tmp$6;
  if (compactMode) {
    tmp$6 = null;
  } else {
    var match$7 = Belt_Array.partition(items, (function (itemId) {
            return !itemId.includes("Chempunk");
          }));
    var itemCount = match$7[0].length;
    var currModsCount = {
      contents: 0
    };
    var numMods = Belt_Array.keep(items, (function (itemId) {
            return Data.itemInfoExn(itemId, set).tags.includes("Mod");
          })).length;
    tmp$6 = React.createElement(React.Fragment, undefined, React.createElement("g", {
              transform: "translate(0, 69)"
            }, Belt_Array.mapWithIndex(items, (function (idx, itemId) {
                    if (Data.itemInfoExn(itemId, set).tags.includes("Mod")) {
                      currModsCount.contents = currModsCount.contents + 1 | 0;
                      return React.createElement("g", {
                                  transform: "translate(69, -42)"
                                }, React.createElement(TeamPlannerHex14$Item, {
                                      itemId: itemId,
                                      idx: idx,
                                      colNum: colNum,
                                      rowNum: rowNum,
                                      onRemove: onRemoveItem
                                    }));
                    }
                    var match = getItemPosition(idx - currModsCount.contents | 0, itemCount - numMods | 0);
                    return React.createElement("g", {
                                key: String(idx),
                                transform: "translate(" + String(match[0]) + ", " + String(match[1]) + ")"
                              }, React.createElement(TeamPlannerHex14$Item, {
                                    itemId: itemId,
                                    idx: idx,
                                    colNum: colNum,
                                    rowNum: rowNum,
                                    onRemove: onRemoveItem
                                  }));
                  }))));
  }
  return React.createElement("g", tmp, React.createElement(Popover, {
                  open: Belt_Option.isSome(menuAnchor),
                  onClose: (function (param) {
                      return Curry._1(setMenuAnchor, (function (param) {
                                    
                                  }));
                    }),
                  anchorEl: menuAnchor,
                  children: React.createElement("div", {
                        className: "py-[6px]"
                      }, React.createElement(MenuItem, {
                            classes: {
                              root: starLevel === 2 ? "text-primary-11" : "text-white1"
                            },
                            onClick: (function (param) {
                                Curry._3(onSetStarLevel, colNum, rowNum, starLevel === 2 ? 0 : 2);
                                return Curry._1(setMenuAnchor, (function (param) {
                                              
                                            }));
                              }),
                            children: React.createElement("div", {
                                  className: "flex"
                                }, React.createElement("div", {
                                      className: "mt-[-2px] pl-[1px]"
                                    }, React.createElement(Star, {
                                          fontSize: "small",
                                          color: "inherit"
                                        })), React.createElement("div", {
                                      className: "pl-[9px]"
                                    }, t("2-Star")))
                          }), React.createElement(MenuItem, {
                            classes: {
                              root: starLevel === 3 ? "text-primary-11" : "text-white1"
                            },
                            onClick: (function (param) {
                                Curry._3(onSetStarLevel, colNum, rowNum, starLevel === 3 ? 0 : 3);
                                return Curry._1(setMenuAnchor, (function (param) {
                                              
                                            }));
                              }),
                            children: React.createElement("div", {
                                  className: "flex"
                                }, React.createElement("div", {
                                      className: "mt-[-2px] pl-[1px]"
                                    }, React.createElement(Star, {
                                          fontSize: "small",
                                          color: "inherit"
                                        })), React.createElement("div", {
                                      className: "pl-[9px]"
                                    }, t("3-Star")))
                          }), React.createElement(MenuItem, {
                            classes: {
                              root: starLevel === 4 ? "text-primary-11" : "text-white1"
                            },
                            onClick: (function (param) {
                                Curry._3(onSetStarLevel, colNum, rowNum, starLevel === 4 ? 0 : 4);
                                return Curry._1(setMenuAnchor, (function (param) {
                                              
                                            }));
                              }),
                            children: React.createElement("div", {
                                  className: "flex"
                                }, React.createElement("div", {
                                      className: "mt-[-2px] pl-[1px]"
                                    }, React.createElement(Star, {
                                          fontSize: "small",
                                          color: "inherit"
                                        })), React.createElement("div", {
                                      className: "pl-[9px]"
                                    }, t("4-Star")))
                          }), tmp$1, traits.includes("TFT12_Arcana") ? React.createElement(MenuItem, {
                              onClick: (function (param) {
                                  Curry._3(onToggleMech, colNum, rowNum, 1);
                                  return Curry._1(setMenuAnchor, (function (param) {
                                                
                                              }));
                                }),
                              children: React.createElement("div", {
                                    className: "flex items-center"
                                  }, React.createElement("div", {
                                        className: "mt-[-2px] pl-[1px]"
                                      }, React.createElement(TraitImage.PlainIcon.make, {
                                            traitId: "TFT12_Arcana",
                                            size: 20
                                          })), React.createElement("div", {
                                        className: "pl-[9px]"
                                      }, traitsT("TFT12_Arcana")))
                            }) : null, React.createElement(MenuItem, {
                            onClick: (function (param) {
                                Curry._1(onRemove, undefined);
                                return Curry._1(setMenuAnchor, (function (param) {
                                              
                                            }));
                              }),
                            children: React.createElement("div", {
                                  className: "flex"
                                }, React.createElement("div", {
                                      className: "mt-[-2px] pl-[1px]"
                                    }, React.createElement(Clear, {
                                          fontSize: "small",
                                          color: "inherit"
                                        })), React.createElement("div", {
                                      className: "pl-[9px]"
                                    }, "Remove"))
                          }))
                }), React.createElement("g", {
                  className: "pointer-events-none"
                }, React.createElement("image", {
                      height: size,
                      href: tmp$2,
                      width: size,
                      clipPath: "polygon(50% 0%, 93.301270189% 25%, 93.301270189% 75%, 50% 100%, 6.698729811% 75%, 6.698729811% 25%)",
                      filter: Caml_obj.caml_equal(grayscale, true) ? "url(#grayscale)" : "",
                      x: "-5",
                      y: "2"
                    })), tmp$4, tmp$5, tmp$6, compactMode ? null : Belt_Array.mapWithIndex(traits, (function (idx, t) {
                      var count = Belt_Option.mapWithDefault(Caml_option.undefined_to_opt(traitCounts.find(function (param) {
                                    return t === param[0];
                                  })), 0, (function (prim) {
                              return prim[1];
                            }));
                      var rank = Sd.traitRank(t, count, set);
                      var match = traits.length;
                      var x = match !== 2 ? (
                          match !== 3 ? Global.f(Math.imul(idx, 25)) + 29.5 : Global.f(Math.imul(idx, 25)) + 4.5
                        ) : Global.f(Math.imul(idx, 25)) + 18;
                      return React.createElement("g", {
                                  key: t,
                                  className: "pointer-events-none",
                                  transform: "translate(" + Global.toFixed(undefined, x) + ", -3)"
                                }, React.createElement(TraitImage.make, {
                                      traitId: t,
                                      rank: rank,
                                      size: 26
                                    }));
                    })), React.createElement(TbHexStarLevel.make, {
                  starLevel: starLevel > 1 ? starLevel : 1
                }));
}

var Unit = {
  make: TeamPlannerHex14$Unit
};

function TeamPlannerHex14(Props) {
  var highlightTrait = Props.highlightTrait;
  var hexSize = Props.hexSize;
  var xGridSize = Props.xGridSize;
  var yGridSize = Props.yGridSize;
  var extended = Props.extended;
  var colNum = Props.colNum;
  var rowNum = Props.rowNum;
  var onDrop = Props.onDrop;
  var onMove = Props.onMove;
  var onDropItem = Props.onDropItem;
  var onMoveItem = Props.onMoveItem;
  var onRemove = Props.onRemove;
  var onRemoveItem = Props.onRemoveItem;
  var onSetStarLevel = Props.onSetStarLevel;
  var onToggleMech = Props.onToggleMech;
  var hex = Props.hex;
  var highlight = Props.highlight;
  var traitCounts = Props.traitCounts;
  var grayscale = Props.grayscale;
  var extraTrait = Props.extraTrait;
  var exaltedUnits = Props.exaltedUnits;
  var match = ReactDnd.useDrag({
        type: "hex",
        item: {
          id: "hex " + String(colNum) + " " + String(rowNum),
          colNum: colNum,
          rowNum: rowNum,
          type: "hex",
          unitId: Belt_Option.map(hex, (function (hex) {
                  return TbUtils14.Content.encodeStr(hex.unit);
                })),
          unitItems: Belt_Option.mapWithDefault(hex, [], (function (hex) {
                  return hex.items;
                })),
          starLevel: Belt_Option.map(hex, (function (hex) {
                  return hex.starLevel;
                })),
          traitCounts: traitCounts
        },
        end: (function (unit, monitor) {
            if (!monitor.didDrop()) {
              return Curry._2(onRemove, unit.colNum, unit.rowNum);
            }
            
          }),
        collect: (function (monitor) {
            return {
                    isDragging: monitor.isDragging()
                  };
          })
      });
  var highlight$1 = hex !== undefined && hex.chosenTrait > 0 ? "var(--secondary-11)" : highlight;
  var tmp;
  if (hex !== undefined) {
    var tmp$1 = {
      dragRef: match[1],
      isDragging: match[0].isDragging,
      hexSize: hexSize,
      hex: hex,
      colNum: colNum,
      rowNum: rowNum,
      onRemove: (function (param) {
          return Curry._2(onRemove, colNum, rowNum);
        }),
      onRemoveItem: onRemoveItem,
      onSetStarLevel: onSetStarLevel,
      onToggleMech: onToggleMech,
      traitCounts: traitCounts,
      exaltedUnits: exaltedUnits
    };
    if (grayscale !== undefined) {
      tmp$1.grayscale = Caml_option.valFromOption(grayscale);
    }
    if (highlightTrait !== undefined) {
      tmp$1.highlightTrait = Caml_option.valFromOption(highlightTrait);
    }
    if (extraTrait !== undefined) {
      tmp$1.extraTrait = Caml_option.valFromOption(extraTrait);
    }
    tmp = React.createElement(TeamPlannerHex14$Unit, tmp$1);
  } else {
    tmp = null;
  }
  var tmp$2 = {
    hexSize: hexSize,
    xGridSize: xGridSize,
    yGridSize: yGridSize,
    extended: extended,
    colNum: colNum,
    rowNum: rowNum,
    onDrop: onDrop,
    onMove: onMove,
    onDropItem: onDropItem,
    onMoveItem: onMoveItem,
    onRemove: onRemove,
    isEmpty: Belt_Option.isNone(hex),
    traitCounts: traitCounts,
    children: tmp
  };
  if (highlight$1 !== undefined) {
    tmp$2.highlight = Caml_option.valFromOption(highlight$1);
  }
  return React.createElement(TbHexWrap.make, tmp$2);
}

var make = TeamPlannerHex14;

export {
  getItemPosition ,
  Item ,
  Unit ,
  make ,
  
}
/* T Not a pure module */
